import { API_DICTIONARY, HTTP_METHODS } from '../../../../constants'
import Fetcher from '../../../../services/Fetcher'
import { DeleteHealthSystemRequest } from './types'

const fetcher = new Fetcher({})

export const deleteCCHS = async (id, data, successMessage) =>
  fetcher.request<DeleteHealthSystemRequest, unknown>({
    url: `${API_DICTIONARY.CONTRACTS}${API_DICTIONARY.CATEGORIES}${id}/${API_DICTIONARY.FACILITIES}${API_DICTIONARY.BULK_REMOVE}`,
    method: HTTP_METHODS.POST,
    successMessage,
    data
  })
